import { ru } from './ru';
import { en } from './en';
import { pl } from './pl';
import { Language } from '../types/language';

export const translations = {
  [Language.PL_ONLY]: pl,
  [Language.PL_EN]: pl,
  [Language.EN]: en,
  [Language.RU]: ru
};

export type TranslationKeys = typeof pl;
export type TranslationFunction = (key: string) => string;
